import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/ExploreButton.css';

const ExploreButton = ({ 
  children = 'Explore',
  leftIcon,
  rightIcon,
  href,
  to,
  onClick,
  variant = 'primary'
}) => {
  const defaultIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M3 8h10M8 3l5 5-5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const content = (
    <>
      <span className="btn-icon-left">
        {leftIcon || defaultIcon}
      </span>
      
      <span className="btn-text">{children}</span>
      
      <span className="btn-icon-right">
        {rightIcon || defaultIcon}
      </span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={`btn-hero-explore btn-hero-${variant}`}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={`btn-hero-explore btn-hero-${variant}`}>
        {content}
      </a>
    );
  }

  return (
    <button className={`btn-hero-explore btn-hero-${variant}`} onClick={onClick}>
      {content}
    </button>
  );
};

export default ExploreButton;